import { useMemo } from "react";

import { getLeafColor } from "Containers/EnvironmentImpact/EnvironmentImpact";
import { getRegionLabel } from "Libs/utils";
import { regionSelector } from "Reducers/project/region";
import { useAppSelector } from "Store/hooks";

import type { RootState } from "Store/configureStore";

export const useProjectRegion = (regionId: string) => {
  const region = useAppSelector((state: RootState) =>
    regionSelector(state, { regionId })
  );

  const regionColor = getLeafColor(
    region?.environmental_impact?.carbon_intensity
  );
  const leafColor = {
    green: "--color-java-600",
    yellow: "--color-gold-600",
    orange: "--orange",
    red: "--color-red-600",
    black: "--color-platform-grey-1000"
  }[regionColor];

  const hasDatas = useMemo(() => {
    return (
      region?.provider?.name &&
      region?.environmental_impact?.carbon_intensity &&
      region?.datacenter?.location
    );
  }, [region]);

  const leafFill = useMemo(() => {
    if (hasDatas && leafColor) return leafColor;
    return "--granite";
  }, [hasDatas, leafColor]);

  const regionLabel = useMemo(() => {
    return getRegionLabel(region?.label || regionId);
  }, [region, regionId]);

  return {
    regionLabel,
    leafFill,
    isGreen: region?.environmental_impact?.green,
    carbonIntensity: region?.environmental_impact?.carbon_intensity
  };
};

export const greenLeafColor = "--color-java-600";
